import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const topLinks = useSelector((state) => state.navigation.topLinkList);

    return <NavigationItem links={contentLinks} topLinks={topLinks} />;
};

export default Navigation;
